import { useQuery } from "@apollo/react-hooks";
import { ApolloError } from "@apollo/client";
import gql from "graphql-tag";
import { BrandSizeGuide } from "src/types/graphql.d";

interface BrandSizeGuideBySlugVars {
  slug: string;
}

interface BrandSizeGuideBySlugData {
  brandSizeGuideBySlug: BrandSizeGuide[];
}

const BRAND_SIZE_GUIDE_BY_SLUG_QUERY = gql`
  query BrandSizeGuideBySlug($slug: String!) {
    brandSizeGuideBySlug(slug: $slug) {
      gender
      text
    }
  }
`;

const useBrandSizeGuideBySlug = (
  slug: string
): {
  loading: boolean;
  data?: BrandSizeGuideBySlugData;
  error?: ApolloError;
} => {
  const { data, loading, error } = useQuery<
    BrandSizeGuideBySlugData,
    BrandSizeGuideBySlugVars
  >(BRAND_SIZE_GUIDE_BY_SLUG_QUERY, {
    variables: { slug },
    fetchPolicy: "cache-first",
  });

  return {
    loading,
    data,
    error,
  };
};

export default useBrandSizeGuideBySlug;
